import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { useContext, useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { AuthContext } from '../context/AuthContext'
import { useLocation, useNavigate } from 'react-router-dom'

const ETradeAuthorization = ({ open, onClose, currentIntegration }) => {
  const { etradeAuthData } = useContext(AuthContext)
  const navigate = useNavigate()
  const location = useLocation()
  const [instructionsAcknowledged, setInstructionsAcknowledged] = useState(false)

  // Reset instructions acknowledgment when dialog opens
  useEffect(() => {
    if (open) {
      setInstructionsAcknowledged(false)
    }
  }, [open])

  const handleAcknowledge = () => {
    setInstructionsAcknowledged(true)
  }

  const handleAuthClick = async (event) => {
    if (!etradeAuthData || !etradeAuthData.auth_url) {
      if (!sessionStorage.getItem('reloaded')) {
        sessionStorage.setItem('reloaded', 'true');
        window.location.reload();
      } else {
        console.error('Reload attempted but data is still missing.');
      }
      return;
    }

    // Clear reload flag once data is valid
    sessionStorage.removeItem('reloaded');
    
    const redirectUrl = etradeAuthData.auth_url
    if (currentIntegration === 'E*Trade') {
      window.open(redirectUrl, '_blank')
    } else if (currentIntegration === 'Coinbase') {
      window.location.href = redirectUrl
    }
  }

  const handleClickHere = async (event) => {
    if (currentIntegration === 'E*Trade') {
      navigate('/VerifyTrade')
    } else if (currentIntegration === 'Coinbase') {
      navigate('/VerifyCoin')
    }
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      aria-labelledby="settings-dialog-title"
      fullWidth
      PaperProps={{
        style: {
          width: '550px',
          maxWidth: '100%',
        },
      }}
      className="setting-dialog"
    >
      <DialogTitle
        id="settings-dialog-title"
        className="d-flex justify-content-between mb-4"
      >
        <div className="d-flex align-items-center">
          <span style={{ marginLeft: '10px' }}>
            {currentIntegration} Authentication
          </span>
        </div>
        <img
          style={{ height: '22px', width: '20px', cursor: 'pointer' }}
          src={`${process.env.PUBLIC_URL}/images/close.png`}
          alt="close"
          className="close-icon"
          role="button"
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent>
        {currentIntegration === 'E*Trade' && !instructionsAcknowledged ? (
          <>
            <div style={{ marginBottom: '20px' }}>
              <h6 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#FFFFFF' }}>
                Before you begin:
              </h6>
              <ol style={{ fontSize: '14px', color: '#FFFFFF', paddingLeft: '20px', lineHeight: '1.8' }}>
                <li style={{ marginBottom: '8px' }}>
                  Ensure you are already logged in to your E*Trade account in the same browser.
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Click the "Authenticate" button below to initiate the authentication process and obtain your verification code.
                </li>
                <li style={{ marginBottom: '8px' }}>
                  If you are unable to retrieve the code, return to this page and click "Authenticate" again.
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Once you have received the code, click "Enter Code" below, input your verification code, and submit to complete the authentication.
                </li>
              </ol>
            </div>
            <div className="mt-1 mb-3 row justify-content-center">
              <Button
                variant="primary"
                type="submit"
                onClick={handleAcknowledge}
                style={{ backgroundColor: '#317CFF', textTransform: 'none' }}
                className="mt-3 w-55 p-2 theme-btn-email"
              >
                {'I Understand, Continue'}
              </Button>
            </div>
          </>
        ) : (
          <>
            <span style={{ fontSize: '16px' }}>
              Please authenticate {currentIntegration} by clicking on below authenticate button
            </span>
            <div className="mt-1 mb-3 row justify-content-center">
              <Button
                variant="primary"
                type="submit"
                onClick={handleAuthClick}
                style={{ backgroundColor: '#317CFF', textTransform: 'none' }}
                className="mt-3 w-55 p-2 theme-btn-email"
              >
                {'Authenticate'}
              </Button>
            </div>
            {(currentIntegration !== 'Coinbase' ||
              location.pathname === '/VerifyTrade') && (
              <>
                <div className="mt-5">
                  <span style={{ fontSize: '16px' }}>
                    After authentication click on below button to enter the code
                  </span>
                </div>
                <div className="mt-1 mb-3 row justify-content-center">
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={handleClickHere}
                    style={{ backgroundColor: '#317CFF', textTransform: 'none' }}
                    className="mt-3 w-55 p-2 theme-btn-email"
                  >
                    {'Enter Code'}
                  </Button>
                </div>
              </>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ETradeAuthorization
